var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.course.driverStartAt && !_vm.course.driverEndAt)?_c('v-tooltip',{attrs:{"top":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
var attrs = ref.attrs;
return [_c('v-icon',_vm._g(_vm._b({attrs:{"color":"success"}},'v-icon',attrs,false),on),[_vm._v("mdi-circle-medium")])]}}],null,false,1947645576)},[_c('span',[_vm._v("Start o "+_vm._s(_vm._f("datetimeHourFirst")(_vm.course.driverStartAt)))])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }